
import TableList from "@components/templates/tablelist";
import {
    HttpGetSkuSalesList,
    HttpBatchDelete
} from "@/service/skusales/skusales";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            // spanTabs: { show: true },
            formData: {
                search: {},
                sidx: "updatedAt",
                sord: "desc"
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            // hasAuth: true,
            showModal: true
        };
    },
    methods: {
        ajaxRequest: HttpGetSkuSalesList,
        interceptRequest (params) {
            return this.handleParams(params);
        },
        handleParams (params) {
            let { search, ...otherParams } = params;
            let { BT_targetMonth, ...otherSearch } = search;
            if (BT_targetMonth) {
                BT_targetMonth = BT_targetMonth.split(" ~ ");
                BT_targetMonth = {
                    GE_targetMonth: BT_targetMonth[0],
                    LE_targetMonth: BT_targetMonth[1]
                };
            }
            return {
                ...otherParams,
                search: {
                    ...otherSearch,
                    ...BT_targetMonth
                }
            };
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        title: "新增",
                        width: 900,
                        // activeid: params,
                        querytype: "add",
                        component: "compUpdate",
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        title: "编辑",
                        querytype: "edit",
                        activeid: params,
                        width: 1200,
                        component: "compUpdate",
                        showFooter: false
                    };
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        title: "删除",
                        width: 450,
                        alert: "error",
                        params: {
                            ids: params
                        },
                        showFooter: true,
                        ajaxRequest: HttpBatchDelete
                    };
                    break;
                case "batchImport":
                    this.operate = {
                        show: true,
                        title: "批量导入",
                        width: 450,
                        component: "compUpload",
                        showFooter: false,
                        data: { contextId: global.SYSID},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductTarget/import",
                        name: "excelFile",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductTarget/downExcel", {}, {
                                executor:'request',
                                download:true,
                            })
                        }
                    };
                    break;
                case 'exportQuery':
                    {
                        let params = this.handleParams(this.formData);
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductTarget/exportByFilter",
                            {
                                ...params,
                            },
                            "download"
                        ).then(res => {
                        }).catch(err => {
                            // this.$VMessage.error(err.message);
                        }
                        )
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: true,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "delete"
                }
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList']),
        ToolsData() {
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "批量导入",
                    operate: "batchImport",
                    more: true
                },
                {
                    name: "批量删除",
                    operate: "delete",
                    more: true,
                    batch: true
                },
                {
                    name: "批量导出",
                    operate: "exportQuery",
                    more: true
                }
            ]
        },
        SearchsData() {
            let stylewidth = "width:210px;"
            return [
                {
                    label: "项目",
                    key: 'IN_lineId',
                    show: true,
                    tag: 'vSelect',
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    options: this.getProductList
                },
                {
                    label: "ERPSKU",
                    tag: 'div',
                    key: 'CN_erpsku',
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.CN_erpsku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.CN_erpsku = row.erpSku;
                                },
                            }
                        })
                    },
                    // style: stylewidth,
                    show: true
                },
                {
                    label: "月度",
                    key: "BT_targetMonth",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm ~ yyyy-mm",
                        type: "daterange",
                        confirm: false
                    },
                    show: true
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    width: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: '项目',
                    key: "lineId",
                    render: (h, { row }) => {
                        let lineItem = this.getProductList.filter(item => {
                            return item.value == row.lineId;
                        })[0];
                        if (!lineItem) return "--";
                        return lineItem.label;
                    },
                },
                {
                    title: 'ERP SKU',
                    key: "erpsku",
                    render: (h, { row }) => {
                        return row.erpsku || "--";
                    },
                },
                {
                    title: "销售总目标（USD）",
                    key: "totalTargetValue",
                },
                {
                    title: '月度',
                    key: "targetMonth"
                },
                {
                    title: "Amazon 1P销售目标",
                    key: "amazon1pTargetValue"
                },
                {
                    title: "Amazon 3P销售目标",
                    key: "amazon3pTargetValue"
                },
                {
                    title: "Homedepot销售目标",
                    key: "homedepotTargetValue"
                },
                {
                    title: "Wayfair销售目标",
                    key: "wayfairTargetValue"
                },
                {
                    title: "Others销售目标",
                    key: "othersTargetValue"
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                    sortable: true
                }
            ];
        },

    },

};
